import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  menu: {
    width: 'fit-content'
  }
}))

export default useStyles
